import { render, staticRenderFns } from "./popup-tags.vue?vue&type=template&id=69fa12c5&"
import script from "./popup-tags.vue?vue&type=script&lang=js&"
export * from "./popup-tags.vue?vue&type=script&lang=js&"
import style0 from "./popup-tags.vue?vue&type=style&index=0&id=69fa12c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports